import { render } from "./App.vue?vue&type=template&id=17ea839f&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script